export default __webpack_public_path__ + "f14c195401801eec53879e51af4e9ccd.png";